const btn = 'bg-bloom-olive font-bloom-sans font-thin text-stone-50 rounded-lg px-8 py-2 drop-shadow-md'

module.exports = btn